export default  {
    tipoTaxa: {
        TAXA: 1,
        DESCONTO: 2,
    }
}


// WEBPACK FOOTER //
// ./src/helpers/tipo-taxa-enum.js